import { SecurityStore } from 'mph-helper';
import Store from '@/store';

export const hasFeature = (feature: string | Array<string>, operator = 'or'): boolean => Store.getters[`${SecurityStore.name}/hasFeature`](feature, operator);
